export default {
  methods: {
    availableTypes (withAll = false) {
      const arr = [
        { value: 'PRODUCT', label: 'Product' },
        { value: 'SERVICE', label: 'Service' }
      ]
      if (withAll) {
        arr.unshift({ value: null, label: 'All Inventory' })
      }
      return arr
    },
    baseVisibleItemName (item, systemType = null) {
      if (systemType) {
        return systemType.singular_name || systemType.name
      }

      return this.availableTypes().find(k => k.value === item.type).label
    },
    baseUnitPriceStr (item) {
      let str = this.friendlyNumber(item.selling_unit_price, true)
      if (item.selling_tax_type !== 'NONE') {
        str += ` ${item.selling_tax_type === 'INCLUSIVE' ? 'inc.' : 'plus'} GST`
      }
      return str
    }
  }
}
